/* eslint-disable tailwindcss/no-arbitrary-value */
import React, { useContext } from 'react';
import { number, shape, string } from 'prop-types';
import { QueryProvider, QueryContext } from '@thd-nucleus/data-sources';
import { TodaysRecommendations } from '@thd-olt-component-react/thd-recs-containers';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { Card, CardTitle, Typography } from '@one-thd/sui-atomic-components';
import { HomepageContext } from '../context/HomepageContext';

export function TodaysRecommendationsForYou({
  id,
  brandTitleMaxLine,
  slidesPerKey,
  renderWidths,
}) {
  const { defaultVariables } = useContext(QueryContext);
  const { defaultCardClass, isB2C } = useContext(HomepageContext);

  const b2cPaperProps = isB2C ? { variant: 'shadow', shadow: 'none' } : {};

  const newDefaultVariables = {
    ...(typeof defaultVariables?.current?.isBrandPricingPolicyCompliant
      === 'boolean' && {
      isBrandPricingPolicyCompliant: defaultVariables.current.isBrandPricingPolicyCompliant
    })
  };

  return (
    <ErrorBoundary name="todays_recs">
      <QueryProvider
        cacheKey="todays_recs"
        defaultVariables={newDefaultVariables}
      >
        <Card
          id={`todays-recommendations-for-you-php-${id}`}
          className={defaultCardClass}
          PaperProps={b2cPaperProps}
          CardContentProps={{ className: 'sui-flex sui-flex-col sui-w-full sui-h-full sui-gap-4 sui-p-4' }}
        >
          <CardTitle header={
            <Typography variant="h3">Today&apos;s Items Picked for You</Typography>
          }
          />
          <TodaysRecommendations
            brandTitleMaxLine={brandTitleMaxLine}
            hideTitle
            requestKey="2zSR74pj5Rq6zDtHENHkAScT4RWsl0pg"
            showFallback
            showLoading
            noATCFulfillment
            entryId={id}
            enableRoundedProductImages={isB2C}
            renderWidths={renderWidths}
            slidesPerKey={slidesPerKey}
          />
        </Card>
      </QueryProvider>
    </ErrorBoundary>
  );
}

TodaysRecommendationsForYou.propTypes = {
  brandTitleMaxLine: number,
  id: string,
  renderWidths: shape({
    minWidthMedium: number,
    minWidthLarge: number,
    maxWidthMedium: number
  }),
  slidesPerKey: shape({
    minWidthMedium: shape({
      4: number,
      6: number,
      8: number,
      12: number,
    }),
    minWidthLarge: shape({
      4: number,
      6: number,
      8: number,
      12: number,
    }),
  }),
};

TodaysRecommendationsForYou.defaultProps = {
  brandTitleMaxLine: undefined,
  id: undefined,
  renderWidths: null,
  slidesPerKey: null,
};
